import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';

/**
 * Loads German, French, and Italian from the app build.
 * Each language file is shipped with the screens that use it, so a new
 * deploy cannot show those screens with an older language file.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoLanguageLoader implements TranslocoLoader {
  getTranslation(lang: string): Promise<Translation> {
    switch (lang) {
      case 'fr':
        return import('../../public/i18n/fr.json').then(file => file.default);
      case 'it':
        return import('../../public/i18n/it.json').then(file => file.default);
      default:
        return import('../../public/i18n/de.json').then(file => file.default);
    }
  }
}
